export default "__VITE_ASSET__5b61437e__"